import _ from 'lodash';
import api from '../../utils/service';

const GET_ADDRESS_SUCCESS = 'redux/address/GET_ADDRESS_SUCCESS';
const GET_ADDRESS_FAIL = 'redux/address/GET_ADDRESS_FAIL';
const CLEAR_ADDRESS = 'redux/address/CLEAR_ADDRESS';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // NOTE - We ignore failures here b/c it's not an essential service
    case GET_ADDRESS_SUCCESS:
      return {
        ...state,
        zipCode: action.data || [],
      };
    case CLEAR_ADDRESS:
      return {
        ...state,
        zipCode: null,
      };
    default:
      return state;
  }
}

export function getaddress(zipCode) {
  return (dispatch) =>
    api
      .get(`/addresses?zipCode=${zipCode}`)
      .then(({ data }) => dispatch(getAddressSuccess(data)))
      .catch((error) => dispatch(getAddressFail(error)));
}

export function getAddressSuccess(data) {
  return {
    type: GET_ADDRESS_SUCCESS,
    data,
  };
}

export function getAddressFail(error) {
  return {
    type: GET_ADDRESS_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function clearAddress() {
  return {
    type: CLEAR_ADDRESS,
  };
}
